import Breadcrumb from "./Breadcrumb";
import Container from "./Container";

const Layout = ({ children }: { children: any }) => {
  return (
    <div className="gap-4 flex flex-col overflow-y-auto px-3">{children}</div>
  );
};

export { Breadcrumb, Container };
export default Layout;
